import { render } from "./RecipeHero.vue?vue&type=template&id=98b92316&scoped=true"
import script from "./RecipeHero.vue?vue&type=script&lang=js"
export * from "./RecipeHero.vue?vue&type=script&lang=js"

import "./RecipeHero.vue?vue&type=style&index=0&id=98b92316&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98b92316"]])

export default __exports__